<template>
  <div :style="{ height, width }" id="EchartsGG" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
      return {
          echartsData:{
            "size":21,
            "list":[
              {"dysl":"70","mc":"2017","dm":"01","sysl":"89"},
              {"dysl":"75","mc":"2018","dm":"02","sysl":"107"},
              {"dysl":"40","mc":"2019","dm":"03","sysl":"61"},
              {"dysl":"70","mc":"2020","dm":"04","sysl":"90"},
              {"dysl":"43","mc":"2021","dm":"05","sysl":"71"},
              {"dysl":"56","mc":"2022","dm":"06","sysl":"100"},
              {"dysl":"75","mc":"2023","dm":"02","sysl":"107"},
              {"dysl":"40","mc":"2024","dm":"03","sysl":"61"},


            ]
          }
      }
  },
  mounted(){
          this.loadEchartsAnimate()
  },
  methods:{
      chartsRelativeSize(percent, derection) {
          var windowW = this.$refs.docement.offsetWidth;
          var windowH = this.$refs.docement.offsetHeight
          var r = 0;
          if ('h' === derection) {
              r = percent * windowH / 100;
          } else {
              r = percent * windowW / 100;
          }
          return r;
      },
      loadEchartsAnimate(){
          var that = this
          var echarts = require('echarts');
          var myCharts = echarts.init(document.getElementById('EchartsGG'));
          var option = {
              color:['#00B49D','#FFA200'],
              tooltip : {
                  trigger: 'axis',
                  textStyle:{
                      color:'#000',
                      fontSize: 30
                  },
                //   formatter: function (params) {
                //       var arr = [];
                //       params.forEach(function (item) {
                //           var N=item.seriesName;
                //           var V = '';
                //           if(item.value>100000000){//亿
                //               V += (item.value/100000000).toFixed(1) + '亿';
                //           }else if( item.value>10000){//万
                //               V += (item.value/10000).toFixed(1) + '万';
                //           }else{
                //               V += item.value;
                //           }
                //           var a = {name:N,value:V};
                //           arr.push(a);
                //       });
                //       var num = '';
                //       arr.forEach(function (item) {
                //           num += item.name+":"+item.value+"<br/>";
                //       });
                //       return params[0].name +"<br>"+ num;
                //   }
              },
              grid: {
                  left: '50px',
                  right: '25px',
                  bottom: '10px',
                  top:'30px',
                  containLabel: true
              },
              legend: {
                  orient: 'horizontal',
                  top:0,
                  right: '20px',
                  itemWidth:30,
                  itemHeight:20,
                  icon:"rect",
                  textStyle:{
                      color:'#fff',
                      fontSize: 26,
                       padding: [0, 0, 0, 10]
                  },
                  data:['总产量','单产量'],
                  z:10001
                  
              },
              xAxis: [
                  {
                      type: 'category',
                      axisLine: {
                          lineStyle: {
                              type: 'solid',
                              color: '#00B49D',//左边线的颜色
                              width: '2'//坐标线的宽度
                          }
                      },
                      axisLabel: {
                          textStyle: {
                              color: '#fff',//坐标值得具体的颜色,
                              fontSize: 26
                          },
                          interval:0
                      },
                      axisTick:false,
                      data: []
                  }
              ],
              yAxis: [
                  {
                      type: 'value',
                      axisLine: {
                        show:true,
                        lineStyle: {
                            type: 'solid',
                            color: '#00B49D',//左边线的颜色
                            width: '2'//坐标线的宽度
                        }
                      },
                      axisLabel: {
                        show:true,
                        textStyle: {
                            color: '#e6e6e6',//坐标值得具体的颜色,
                            fontSize:26
                        }
                      },
                      axisTick:false,
                      splitLine: {  //坐标轴在grid区域中的分隔线（网格中的横线）
                        show: true,
                        lineStyle: {
                            color: '#00B49D',
                            width: 1,
                            type: 'solid',
                        }
                      }
                  }
              ],
              series : [
                  {
                    name:'总产量',
                    type:'bar',
                    barGap:0.5,
                    barWidth:40,
                    data:[],
                    itemStyle: {
                        normal: {
                            // //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                            // barBorderRadius:[5, 5, 5, 5],
                            borderColor: '#306269',
                            color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                                { offset: 0, color: '#00B49D' },
                                { offset: 1, color: '#00B49D' }
                                ],
                            )}
                    },
                  },{
                    name:'单产量',
                    type:'bar',
                    barGap:0.5,
                    barWidth:40,
                    data:[],
                    itemStyle: {
                        normal: {
                            //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                            // barBorderRadius:[5, 5, 5, 5],
                            borderColor: '#306269',
                            color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                                { offset: 0, color: '#FFA200' },
                                { offset: 1, color: '#FFA200' }
                                ],
                            )}
                        
                    }
                  }
              ]
          };
          for(var i=0;i<this.echartsData.list.length && i<5;i++){
              option.xAxis[0].data.push( that.echartsData.list[i].mc);
              option.series[0].data.push( that.echartsData.list[i].sysl);
              option.series[1].data.push( that.echartsData.list[i].dysl);
          }
          myCharts.setOption(option);

          if(window.hbfxInterval){
              clearInterval(window.hbfxInterval);
          }
          window.hbfxIndex = 0;
          // window.hbfxInterval = setInterval(function () {
          //     option.xAxis[0].data.shift();
          //     option.xAxis[0].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].mc);
          //
          //     option.series[0].data.shift();
          //     option.series[0].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].sysl);
          //
          //     option.series[1].data.shift();
          //     option.series[1].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].dysl);
          //
          //     myCharts.setOption(option);
          //     window.hbfxIndex ++;
          // },2000)
      }
  }
}
</script>
<style lang="less">
  .min-body{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #010827;
  }
  
</style>
